import { Button } from '@mantine/core';
import { AiOutlineReload } from 'react-icons/ai';
import { useState } from 'react';
import { Product } from '../../products/types';
import { updateStripeProduct } from '../services/StripeProductService';

interface UpdateStripeProductButtonProps {
    product: Product;
}

export const UpdateStripeProductButton = ({ product }: UpdateStripeProductButtonProps) => {
    const [loading, setLoading] = useState(false);

    const handleUpdate = async () => {
        if (!product.billingProviderRecordId) return;
        
        setLoading(true);
        try {
            await updateStripeProduct(product.billingProviderRecordId, product.id, {
                name: product.name,
                description: product.shortDescription || product.longDescription,
                active: product.status === 'Active'
            });
        } catch (error) {
            console.error('Failed to update Stripe product:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            leftSection={<AiOutlineReload size={16} />}
            size="xs"
            variant="light"
            loading={loading}
            onClick={handleUpdate}
        >
            Update Stripe
        </Button>
    );
};